module.exports = __webpack_public_path__ + "images/stickers/star@2x.27460fa90f9753396db3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/star@2x.png
// module id = hA/h
// module chunks = 1